import type { MetricPeriodTranslateFn } from "./metricsUtils";

/** i18n key: dashboard-kpi-{id with underscores as hyphens} */
export function dashboardKpiTitle(
  id: string,
  fallback: string,
  t: MetricPeriodTranslateFn
): string {
  const slug = id.replace(/_/g, "-");
  return t(`dashboard-kpi-${slug}`, fallback);
}

/**
 * Chart segment / axis labels from {@link stringFormatter}(enum) (English Title Case).
 * Uses stable slug keys `dashboard-dist-{slug}` so locales can override without a giant map.
 */
export function translateDashboardDistributionLabel(
  label: string,
  t: MetricPeriodTranslateFn
): string {
  const trimmed = label.trim();
  if (!trimmed) return label;
  if (trimmed === "N/A") {
    return t("dashboard-dist-n-a", "N/A");
  }
  const slug = trimmed
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  if (!slug) return label;
  return t(`dashboard-dist-${slug}`, trimmed);
}
